import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { segmentsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useSegmentsState = () => React.useContext(Context) || {}
export const useSegments = () => useSegmentsState()?.segments || []

const QUERY = gql`
  query Segments($page: Int, $search: String, $sort: SegmentSort, $filter: SegmentFilter) {
    segments(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      insertedAt
      updatedAt
    }
  }
`

const SegmentsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: { page: 1, search, sort: { field: field || 'NAME', type }, filter },
    client: segmentsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default SegmentsLoader
